var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureRolesLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEF0F3",
    d: "M18.099 0c1.01 0 1.94.596 2.445 1.552l.09.183 2.689 5.943c.452 1 1.347 1.654 2.347 1.728l.188.007h28.025c.492 0 .956.139 1.36.383H0V3.138C0 1.467 1.18.1 2.67.005L2.835 0h15.263z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M41 8.9L2 9",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M57.105 25.91V11.73c0-1.566-1.27-2.835-2.835-2.835H26.245c-1.074-.001-2.056-.608-2.536-1.569l-2.688-5.371C20.541.995 19.56.387 18.486.387H3.223C1.656.387.387 1.657.387 3.223v42.539c0 1.566 1.27 2.836 2.836 2.836h19.851M41.508 51.434L31.582 51.434 31.582 61.359",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M63.96 54.93c-2.397 7.03-9.366 11.441-16.746 10.6-7.38-.841-13.177-6.708-13.93-14.096M55.688 45.762L65.613 45.762 65.613 35.836",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M33.235 42.265c2.398-7.03 9.367-11.44 16.746-10.6 7.38.841 13.177 6.708 13.93 14.097",
    transform: "translate(1 1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureRolesLarge);
export default __webpack_public_path__ + "static/media/azure-roles-large.3c249203.svg";
export { ForwardRef as ReactComponent };